import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Grid, IconButton } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import { lendingPartnerDealShare } from "assets/properties/properties";
import { productDealShareType } from "assets/properties/properties";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
const PartnerDealCreate = ({ classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [partnerName, setPartnerName] = useState("");
  const [partnerNameState, setPartnerNameState] = useState(false);
  const [partnerDealPercentageState, setPartnerDealPercentageState] =
    useState(false);
  const [partnerDealPercentage, setPartnerDealPercentage] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [partnerDealData, setPartnerDealData] = useState([]);
  const [partnerDealName, setPartnerDealName] = useState(
    params?.code ? params?.code : ""
  );
  const [selectShareType, setSelectShareType] = useState("");
  const [partnerDealNameState, setPartnerDealNameSate] = useState(false);
  const [partnerDealTypeState, setPartnerDealTypeState] = useState(false);
  const [dealShares, setDealShares] = useState([
    { name: "", type: "", percentage: "", isDisbursal: false, saved: false },
  ]);
  const [disabledTypes, setDisabledTypes] = useState([]);
  // message popup
  useEffect(()=>{
    getParentDealData();
  },[]);

  const getParentDealData = async () => {
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.PARTNER_DEAL_DEAL_SHARE_FIND_DEAL_CODE + params?.code,
        authToken: authToken,
      });
      setCallInProgress(false);
      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
      } else {
        const takenTypes = result?.data?.map((item) => item.type) || [];
        setDisabledTypes(takenTypes);
      }
    };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (partnerName === "") {
      setPartnerNameState(true);
    } else {
      setPartnerNameState(false);
    }
    if (partnerDealPercentage === "") {
      setPartnerDealPercentageState(true);
    } else {
      setPartnerDealPercentageState(false);
    }
    if (partnerDealName === "") {
      setPartnerDealNameSate(true);
    } else {
      setPartnerDealNameSate(false);
    }
    if (selectShareType === "") {
      setPartnerDealTypeState(true);
    } else {
      setPartnerDealTypeState(false);
    }
    if (
      partnerDealName &&
      partnerName &&
      selectShareType &&
      partnerDealPercentage
    ) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if (params.partnerId) {
      GetData();
    }
  }, [params?.partnerId]);
  useEffect(() => {
    if (selectShareType === "DISBURSAL") {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [selectShareType]);

  const partnerGetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PARTNER_DEAL_FIND,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const partnerDeal = result?.data?.filter(
        (item) => !item?.self && item?.active
      );
      setPartnerDealData(partnerDeal);
    }
  };

  useEffect(() => {
    partnerGetData();
  }, []);
  const GetData = async () => {
  setCallInProgress(true);
  const result = await apiHandler({
    url: endpoint.PARTNER_DEAL_SHARE_GETDATA + params.partnerId,
    authToken: authToken,
  });
  setCallInProgress(false);

  if (result?.data?.error_code) {
    toastUpdate("Error", result?.data?.user_description, true);
  } else {
    const apiData = Array.isArray(result?.data) ? result?.data : [result?.data];

    const mappedShares = apiData.map((item) => ({
      name: item?.name || "",
      type: item?.type || "",
      percentage: item?.percentage || "",
      isDisbursal: item?.isDisbursal || false,
      saved: false,
      id: item?.id || null,
    }));

    setDealShares(mappedShares);

    setPartnerDealName(apiData[0]?.partnerDealCode);
  }
};

  const updateRoleInformation = async (index) => {
     const deal = dealShares[index];

    if(Number(deal?.percentage) < 0 || Number(deal?.percentage) > 100 ){
      toastUpdate("Error", "Percentage must be between 0 to 100", true);
      return;
    }

    if (!deal.name || !deal.type || !deal.percentage) {
      toastUpdate("Error", "Please fill all fields before saving.", true);
      return;
    }

    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.PARTNER_DEAL_SHARE_UPDATE + params?.partnerId,
      method: "PUT",
      authToken: authToken,
      data: {
        name: deal.name,
        partnerDealCode: partnerDealName,
        percentage: deal.percentage,
        isDisbursal: deal.isDisbursal,
        type: deal.type,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      const updated = [...dealShares];
      updated[index].saved = true;
      setDealShares(updated);
      toastUpdate("Success", "Deal Share edited successfully.", true);
    }
  };

  const handleroleSubmit = async (index) => {
    const deal = dealShares[index];

    if(Number(deal?.percentage) < 0 || Number(deal?.percentage) > 100 ){
      toastUpdate("Error", "Percentage must be between 0 to 100", true);
      return;
    }
    // basic validation
    if (!deal.name || !deal.type || !deal.percentage) {
      toastUpdate("Error", "Please fill all fields before saving.", true);
      return;
    }

    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.PARTNER_DEAL_SHARE_CREATE,
      method: "POST",
      authToken: authToken,
      data: {
        name: deal.name,
        partnerDealCode: partnerDealName,
        percentage: deal.percentage,
        isDisbursal: deal.isDisbursal,
        type: deal.type,
      },
    });
    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      // mark this row as saved
      const updated = [...dealShares];
      updated[index].saved = true;
      setDealShares(updated);
      toastUpdate("Success", "Deal Share saved successfully.", true);
    }
  };

  const statusUpdate = async (checked) => {
    setIsActive(checked);
  };

  const handlePartnerCode = (e) => {
    setPartnerDealName(e);
  };
  const handleShareType = (e) => {
    setSelectShareType(e);
  };
  const handlecancelrole = () => {
    navigate(`/coreservice/partnerDealShare/${params?.code}`);
  };
  const handleDealShareChange = (index, field, value) => {
    const updated = [...dealShares];
    updated[index][field] = value;
    if (field === "type") {
      updated[index].isDisbursal = value === "DISBURSAL";
    }
    setDealShares(updated);
  };

  const addDealShareRow = () => {
    // check if the last row is saved before adding a new one
    if (!dealShares[dealShares.length - 1].saved) {
      toastUpdate(
        "Error",
        "Please save the current row before adding another.",
        true
      );
      return;
    }
    setDealShares([
      ...dealShares,
      { name: "", type: "", percentage: "", isDisbursal: false, saved: false },
    ]);
  };

  const deleteDealShareRow = (index) => {
    const updated = [...dealShares];
    updated.splice(index, 1);
    setDealShares(updated);
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={
            params.partnerId
              ? lendingPartnerDealShare?.title2
              : lendingPartnerDealShare?.title1
          }
          button2=" Cancel"
          button2click={handlecancelrole}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Partner Deal Name"
              value={partnerDealName}
              data={partnerDealData}
              setState={handlePartnerCode}
              id="receipt_purpose"
              type="bool"
              error={partnerDealNameState}
              setError={setPartnerDealNameSate}
              disabled={true}
            />
          </Grid>
          <Grid item sm={6} md={8} />
          {dealShares?.map((deal, index) => (
            <React.Fragment key={index}>
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                className={classes.fieldContaienr}
              >
                <CustomeTextField
                  label="Name"
                  required
                  value={deal.name}
                  setState={(val) => handleDealShareChange(index, "name", val)}
                  disabled={deal.saved}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={2}
                className={classes.fieldContaienr}
              >
                <CustomSelectNew
                  label="Type"
                  value={deal.type}
                  data={productDealShareType}
                  setState={(val) => handleDealShareChange(index, "type", val)}
                  type="bool"
                  disabledOptions={[
                    ...disabledTypes,
                    ...dealShares.map((d, i) => (i !== index ? d.type : null)).filter(Boolean)
                  ]}
                  disabled={deal.saved}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={2}
                className={classes.fieldContaienr}
              >
                <CustomeTextField
                  label="Percentage"
                  required
                  value={deal.percentage}
                  type="number"
                  setState={(val) =>
                    handleDealShareChange(index, "percentage", val)
                  }
                  disabled={deal.saved}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={2}
                className={classes.fieldContaienr}
              >
                <Button
                  className={`${classes.button2} ${classes.schemeButton}`}
                  onClick={() => params?.partnerId ? updateRoleInformation(index) : handleroleSubmit(index)}
                  id="button"
                  disabled={deal.saved}
                >
                  {deal.saved ? "Saved" : "Save"}
                </Button>
              </Grid>
              {dealShares?.length > 1 && (
                <IconButton
                  aria-label="Delete Disbursal"
                  onClick={() => deleteDealShareRow(index)}
                  style={{ padding: "0px", marginTop: "2%" }}
                >
                  <DeleteIcon
                    style={{
                      color: "red",
                      cursor: "pointer",
                    }}
                  />
                </IconButton>
              )}
              {index === dealShares.length - 1  && !params.partnerId && (
                <IconButton
                  aria-label="Add Deal Share"
                  onClick={addDealShareRow}
                  style={{ padding: "0px", marginTop: "2%" }}
                  disabled={!deal.saved}
                >
                  <AddIcon style={{ color: deal.saved ? "green" : "gray" }} />
                </IconButton>
              )}
              <Grid
                item
                xs={12}
                sm={6}
                md={2}
                className={classes.fieldContaienr}
                style={{ marginTop: "0px", padding: "0px" }}
              >
                <label
                  style={{
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    margin: 0,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={deal?.isDisbursal}
                    disabled
                    style={{ width: "20px", height: "20px" }}
                  />
                  Is Disbursal
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12} />
            </React.Fragment>
          ))}
        </Grid>
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default PartnerDealCreate;